/* eslint-disable */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {StyleSheet, css} from 'aphrodite';

import {mapStateToProps, mapDispatchToProps} from '../../utils';
import {updateAppState} from '../../actions/applicationState';

import {Theme} from '../../config/theme';
import Body from '../../components/Body';
import Footer from '../../components/Footer';
import UnauthenticatedHeader from '../../components/UnauthenticatedHeader';
import Loader from '../../components/Loader';
import {sendMemberVerificationRequest} from '../../actions/user';

let styles;

class Verify extends Component {
  constructor(props) {
    super(props);

    this.state = {
      verifying: true,
      successful: true,
      errorMessage: null,
    };

    this.openLoginHandler = this.loginModalOpenHandler.bind(this);
  }

  componentDidMount() {
    const ID = this.findGetParameter('Member');
    const VerificationToken = this.findGetParameter('VerificationToken');
    // console.log('ID, VerificationToken', ID, VerificationToken);

    this.props.dispatch(
      sendMemberVerificationRequest(ID, VerificationToken)
    ).then((response) => {
      if (response.status === 200) {
          this.setState({
            verifying: false,
            successful: true,
          });
      } else {
        this.setState({
          errorMessage: response.data.error,
          verifying: false,
          successful: false,
        });
      }
    });
  }

  findGetParameter(parameterName) {
    let result = null,
      tmp = [];
    let items = location.search.substr(1).split("&");
    for (var index = 0; index < items.length; index++) {
      tmp = items[index].split("=");
      if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
    }
    return result;
  }

  loginModalOpenHandler() {
    this.props.dispatch(updateAppState({
      login_modal_open: true,
    }));
  }

  render() {
    return (
      <Body hasFooter>
      <UnauthenticatedHeader openLoginHandler={this.openLoginHandler}/>
      {
        this.state.verifying ?
          (<Loader text={'Verifying'}/>) :
          this.state.successful === true ? (
            <div className={css(styles.container)}>
              <h1 className={css(styles.title)}>Your account has been activated</h1>
              <p className={css(styles.paragraph)}>You can now <a className={css(styles.login_link)} onClick={this.openLoginHandler}>log in</a> using your email address and password. It's time to set up your profile and get dog sharing!</p>
            </div>
          ) : (
            <div className={css(styles.container)}>
              <h1 className={css(styles.title)}>Oops, we couldn't verify you.</h1>
              <h2 className={css(styles.subtitle)}>{this.state.errorMessage}</h2>
              <h3 className={css(styles.message)}>Please double check the email link we sent you and try again later.</h3>
            </div>
          )
      }
      <Footer user={{}}/>
      </Body>
    );
  }
}

Verify.propTypes = {
  dispatch: PropTypes.func.isRequired,
};


styles = StyleSheet.create({
  container: {
    padding: '70px 15px',
    position: 'relative',
    zIndex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 515,
    marginTop: 80,
    flexDirection: 'column',
  },
  title: {
    fontFamily: Theme.font_family_heading,
    fontSize: 60,
    fontWeight: Theme.font_weight_heading,
    color: Theme.black,
    marginBottom: 30,

    [Theme.mobile_query]: {
      fontSize: 45,
    },
  },
  subtitle: {
    fontFamily: Theme.font_family_heading,
    fontSize: 40,
    fontWeight: Theme.font_weight_heading,
    color: Theme.black,
    marginBottom: 30,

    [Theme.mobile_query]: {
      fontSize: 25,
    },
  },
  message: {
    fontFamily: Theme.font_family_heading,
    fontSize: 30,
    fontWeight: Theme.font_weight_heading,
    color: Theme.black,

    [Theme.mobile_query]: {
      fontSize: 25,
    },
  },
  login_link: {
    cursor: 'pointer',
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(Verify);



// WEBPACK FOOTER //
// ./src/views/Verify/index.js